export class ProduitLightOutput {
    id = 0
    nom = ''
    code = ''
    codeBarre = ''
    inventaireEffectueId = 0
    identifiantProduit = ''
    identifiantProduitCorrige = null as string | null
    nouveauStatut = null as null | Inventaire_StatutModifie
    ancienStatut = null as null | Inventaire_StatutModifie
    commentaire = null as string | null
    isPeremptionCourte = false
}

export enum Inventaire_StatutModifie {
    EnTrop = 1,
    Manquant,
    Ok,
    Regularise
}

export function TraitementInventaireProduitStatut_ToText(input: Inventaire_StatutModifie) {
    switch (input) {
        case Inventaire_StatutModifie.EnTrop:
            return 'En trop'
        case Inventaire_StatutModifie.Manquant:
            return 'Manquant'
        case Inventaire_StatutModifie.Ok:
            return 'Ok'
        case Inventaire_StatutModifie.Regularise:
            return 'Regularisé'
    }
}
